import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { stringify } from 'qs';
import { ReactNode } from 'react';
import { authLogoutUrl } from '~/components/Auth';
import { T } from '~/components/I18n/Translation';
import { useMember } from '~/components/Member/Member.hooks';
import { UseDosiminQueryOptions } from '~/components/Query/Query.hooks';

//expired_soon is calculated at client
export type W8benStatus = 'UNREGISTERED' | 'REGISTERED' | 'DISAGREE' | 'EXPIRED' | 'EXPIRED_SOON';

export type W8ben = {
  status: W8benStatus;
  registrationDeadline?: Date;
  expiredAt?: Date;
};

export const w8benMap: Partial<Record<W8benStatus, Record<string, ReactNode>>> = {
  UNREGISTERED: {
    title: <T name="citizen_land_detail_w8ben_status_1" />,
    cta: <T name="citizen_land_detail_w8ben_cta_1" />,
  },
  DISAGREE: {
    title: <T name="citizen_land_detail_w8ben_status_2" />,
    cta: <T name="citizen_land_detail_w8ben_cta_2" />,
  },
  EXPIRED: {
    title: <T name="citizen_land_detail_w8ben_status_3" />,
    cta: <T name="citizen_land_detail_w8ben_cta_3" />,
  },
  EXPIRED_SOON: {
    title: <T name="citizen_land_detail_w8ben_status_3" />,
    cta: <T name="citizen_land_detail_w8ben_cta_3" />,
  },
};

const PROFILE_URL = import.meta.env.VITE_PROFILE_URL;
export const registerW8benUrl = `${PROFILE_URL}/w-8ben?${stringify({ logout_url: authLogoutUrl })}`;

export const w8benUrl = '/api/citizen/v1/lands/check/w-8ben';
export const transformW8ben = (response: W8ben) => ({
  ...response,
  registrationDeadline: response.registrationDeadline
    ? new Date(response.registrationDeadline)
    : undefined,
  expiredAt: response.expiredAt ? new Date(response.expiredAt) : undefined,
});

export const getW8ben = async () => {
  const { data } = await axios.get<W8ben>(w8benUrl);
  return transformW8ben(data);
};

export const useW8ben = (options?: UseDosiminQueryOptions<W8ben>) => {
  const {
    data: { isLoggedIn },
  } = useMember();
  return useQuery<W8ben>({
    queryKey: ['wallet', 'w8ben'],
    queryFn: getW8ben,
    initialData: { status: 'UNREGISTERED' },
    enabled: isLoggedIn,
    ...options,
  });
};
